import React from 'react'
import { AssetRouteImport } from './Imports'
const { RoutesMap, AddAsset, AssetDetails, UpdateAsset, AssetLocation, AssetLocationDetails, AssetList, AddAssetIssue, AssetIssueList, AddInventory, GrnDetails, GrnStockList, AddAmc, UpdateAmc, AmcList, AmcDetails } = AssetRouteImport

const AssetRoute = () => {
    return [
        {
            path: RoutesMap.ADD_ASSET.path,
            element: <AddAsset />
        },
        {
            path: RoutesMap.UPDATE_ASSET.path,
            element: <UpdateAsset />
        },
        {
            path: RoutesMap.ASSET_LIST.path,
            element: <AssetList />
        },
        {
            path: RoutesMap.STOCK_LIST.path,
            element: <GrnStockList />
        },
        {
            path: RoutesMap.GRN_DETAILS.path,
            element: <GrnDetails />
        },


        {
            path: RoutesMap.ASSET_DETAILS.path,
            element: <AssetDetails />
        },

        {
            path: RoutesMap.ADD_ASSET_ISSUE.path,
            element: <AddAssetIssue />
        },
        // {
        //     path: RoutesMap.UPDATE_ASSET.path,
        //     element: <UpdateAsset />
        // },
        {
            path: RoutesMap.ASSET_ISSUE_LIST.path,
            element: <AssetIssueList />
        },

        {
            path: RoutesMap.ASSET_LOCATION.path,
            element: <AssetLocation />
        },
        {
            path: RoutesMap.ASSET_LOCATION_DETAILS.path,
            element: <AssetLocationDetails />
        },
        {
            path: RoutesMap.ADD_INVENTORY.path,
            element: <AddInventory />
        },

        {
            path: RoutesMap.ADD_AMC.path,
            element: <AddAmc />
        },
        {
            path: RoutesMap.UPDATE_AMC.path,
            element: <UpdateAmc />
        },
        {
            path: RoutesMap.AMC_LIST.path,
            element: <AmcList />
        },
        {
            path: RoutesMap.AMC_DETAILS.path,
            element: <AmcDetails />
        },



    ]
}

export default AssetRoute;